<script lang="ts">
    import { ariaKeyDownA11yHandler } from '$common/utils/ariaKeyDownA11y';
    import cn from '$common/utils/cn';

    export let label: string;
    export let onToggleCheck: () => void | undefined = () => {};
    export let labelClass: string | undefined = '';
    export let containerClass: string | undefined = '';
    export let isChecked: boolean = false;
</script>

<div
    class={cn('flex cursor-pointer gap-s p-m', containerClass)}
    on:click={onToggleCheck}
    role="button"
    tabindex="0"
    {...ariaKeyDownA11yHandler(onToggleCheck)}
>
    <div class="size-m">
        <input type="checkbox" checked={isChecked} />
    </div>
    <div class={labelClass}>{label}</div>
</div>
